export class Timer {
    constructor(interval) {
        this.timer = null;
        this.interval = interval;
    }
    start = (callBack, params, isNoDelay) => {
        if (typeof callBack !== 'function')
            return;
            
        if (isNoDelay) {
            if (params) {
                callBack(params);
            }
            else {
                callBack();
            }
        }


        this.timer = setInterval(() => {
            if (params) {
                callBack(params);
            }
            else {
                callBack();
            }
        }, this.interval);
    }
    
    dispose = () => {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
}